import apiClient from './apiClient';

export const RESERVE_LOW_THRESHOLD = 500;

/* ── lightweight shared cache so the sidebar + pages stay in sync ── */
let _cachedSold = null;
const _listeners = new Set();

export const getCachedSold = () => _cachedSold;
export const subscribeReserve = (fn) => { _listeners.add(fn); return () => _listeners.delete(fn); };

export const setCachedSold = (v) => {
  const n = (v === null || v === undefined || v === '') ? null : parseFloat(v);
  _cachedSold = Number.isNaN(n) ? null : n;
  _listeners.forEach(fn => fn(_cachedSold));
};

export const getReserve = async () => {
  const data = await apiClient.get('/borderou-reserve/').then(r => r.data);
  setCachedSold(data.sold);
  return data;
};

export const updateReserve = async (sold) => {
  const data = await apiClient.patch('/borderou-reserve/', { sold }).then(r => r.data);
  setCachedSold(data.sold);
  return data;
};

// Generate a borderou for the fees checked since the last one.
// payload: { lines: [{ key, suma }], marca, nr_depozit, clase: [9, 35] }
// Returns { procedura, borderou, sold }.
export const generateBorderou = async (procId, payload) => {
  const data = await apiClient.post(`/proceduri/${procId}/borderou/`, payload).then(r => r.data);
  if (data.sold !== undefined) setCachedSold(data.sold);
  return data;
};

// Download (or re-download) a generated borderou as a .docx.
// `name` (from the borderou record) is preferred; the Content-Disposition
// header is the fallback (it may be hidden cross-origin).
export const downloadBorderou = async (procId, borderouId, name) => {
  const res = await apiClient.get(
    `/proceduri/${procId}/borderou/${borderouId}/download/`,
    { responseType: 'blob' },
  );
  let filename = name;
  if (!filename) {
    const disposition = res.headers['content-disposition'] || '';
    const match = disposition.match(/filename="(.+?)"/);
    filename = match ? match[1] : `Borderou-${borderouId}.docx`;
  }
  const url = URL.createObjectURL(new Blob([res.data], {
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  }));
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
};
